function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1c6.1 0 11 4.9 11 11s-4.9 11-11 11S1 18.1 1 12 5.9 1 12 1m0-1C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.2c0-.7-.1-1.2-.2-1.7h-7.7v3h4.5c-.1.8-.6 1.9-1.7 2.6v.1l2.4 1.9h.2c1.6-1.3 2.5-3.4 2.5-5.9",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2 20.2c2.2 0 4.1-.7 5.4-2l-2.6-2c-.7.5-1.6.8-2.8.8-2.2 0-4-1.4-4.6-3.4h-.1l-2.5 2v.1c1.2 2.6 4 4.5 7.2 4.5",
    style: {
      fill: "#34a853"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.6c-.2-.5-.3-1.1-.3-1.6 0-.6.1-1.1.3-1.6v-.1L5 8.3h-.1C4.3 9.4 4 10.7 4 12s.3 2.6.9 3.7l2.6-2.1",
    style: {
      fill: "#fbbc05"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2 7c1.5 0 2.6.7 3.2 1.2L17.6 6c-1.4-1.3-3.3-2.1-5.5-2.1-3.2 0-6 1.8-7.3 4.5l2.6 2C8.2 8.4 10 7 12.2 7",
    style: {
      fill: "#eb4335"
    }
  }));
};
export default SvgGoogle;